<template>
    <main id="main-frontend-app">
        <header>
            <nav class="small-nav">
                <div class="container d-flex">
                    <ul class="nav">
                        <li>
                            <router-link :to="{name: 'contact'}">Apoio ao Cliente</router-link>
                        </li>
                        <!--                    <li>-->
                        <!--                        <router-link :to="{name: 'faqs'}">Perguntas Frequentes</router-link>-->
                        <!--                    </li>-->
                    </ul>
                    <ul class="nav ms-auto">
                        <li>
                            <span>Apoio ao Cliente:</span>
                            <a class="d-inline-block" target="_blank" href="tel:+351229732014">+351 229 732 014</a>
                        </li>
                    </ul>
                </div>
            </nav>
            <nav class="main-nav">
                <div class="container d-flex">
                    <router-link :to="{name: 'home'}" class="logo me-auto">
                        <img src="/images/logo.png" alt="">
                    </router-link>
                    <ul class="nav my-auto" :class="{show: showNav}">
                        <li>
                            <router-link :to="{name: 'category.view'}">
                                <span>Loja</span>
                            </router-link>
                        </li>
                        <li v-for="cat in categories">
                            <router-link :to="{name: 'category.view', params: {category: cat.highlightable.id}}">
                                <span>{{ cat.highlightable.name }}</span>
                            </router-link>
                        </li>
                    </ul>
                    <ul class="nav-bts my-auto">
                        <li v-if="$auth.check()" class="me-4">
                            <router-link :to="{name:'reserved.dashboard'}" class="my-auto text-center logged-btn">
                                <div>{{ $auth.user().name }} {{ $auth.user().surname }}</div>
                                <div><strong>Área Reservada</strong></div>
                            </router-link>
                        </li>
                        <li class="my-auto">
                            <router-link id="cart-btn-main" tag="button" :to="{name:'cart'}">
                                <span class="counter">{{ getCartCount }}</span>
                                <img src="/images/cart-icon.png" alt="">
                            </router-link>
                        </li>
                        <li v-if="!$auth.check()" class="ms-1 my-auto">
                            <router-link tag="button" :to="{name:'auth'}">
                                <img src="/images/user-lock.png" alt="">
                            </router-link>
                        </li>
                        <li class="ms-1 my-auto mobile-hamb-btn">
                            <button @click.prevent="showNav = !showNav">
                                <span class="bar"></span>
                                <span class="bar"></span>
                                <span class="bar"></span>
                            </button>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
        <router-view id="main-frontend-content"></router-view>
        <footer>
            <div class="footer-content container">
                <div class="contacts">
                    <h3>Contactos</h3>
                    <p>R. Dom Afonso Henriques 1 <br>4435-005 Rio Tinto</p>
                    <p><a href="tel:+351229732014">+351 229 732 014</a></p>
                </div>
                <form @submit.prevent="ContactSubmit" class="quick-contact mx-auto">
                    <h3>Contacto Rápido</h3>
                    <div class="row">
                        <div class="col-md-6">
                            <input type="text" class="form-control" placeholder="Nome" v-model="contact.name" required>
                        </div>
                        <div class="col-md-6">
                            <input type="email" class="form-control" placeholder="E-mail" v-model="contact.email" required>
                        </div>
                    </div>
                    <textarea class="form-control mt-4" rows="5" placeholder="A sua mensagem ..." v-model="contact.msg" required></textarea>
                    <div class="text-end mt-3">
                        <button class="btn btn-primary">
                            <img src="/images/msg-icon.png" alt="">
                            <span>Enviar</span>
                        </button>
                    </div>
                </form>
                <div class="novidades d-flex flex-column">
                    <form @submit.prevent="NewsletterSubscribe">
                        <h3>Novidades</h3>
                        <p>Subscreva a nossa newsletter</p>
                        <div class="d-flex">
                            <input type="email" class="form-control" placeholder="E-mail" v-model="newsletter.email">
                            <button type="submit" class="btn">></button>
                        </div>
                        <div class="form-check mt-3">
                            <input type="checkbox" class="form-check-input" id="newsletter-rgpd-accept" required>
                            <label class="form-check-label" for="newsletter-rgpd-accept">Concordo com a politica de
                                privacidade</label>
                        </div>
                    </form>
                    <section class="dev-by text-end mt-auto">
                        <p class="m-0 p-3">
                            <strong>Desenvolvido por:</strong>
                            <br><a href="https://duplanet.pt/">Duplanet.pt - Soluções Multimédia</a>
                        </p>
                    </section>
                </div>
            </div>
            <section class="footer-bottom">
                <p class="m-0">Todos os Direitos Reservados &copy {{ new Date().getFullYear() }}</p>
            </section>
        </footer>
    </main>
</template>

<script>
import CartMixin from "../mixins/CartMixin";

export default {
    name: "AppComponent",
    metaInfo: {
        title: '',
        titleTemplate: 'Farmácia Areosa %s',
        htmlAttrs: {
            lang: 'pt',
            amp: false
        },
        meta: [
            {charset: 'utf-8'},
            {name: 'viewport', content: 'width=device-width, initial-scale=1'},
            {
                name: "description",
                content: ''
            },
            {
                name: "keywords",
                content: ''
            },
            {name: "author", content: 'Duplanet.pt - Soluções Multimédia'}
        ],
    },
    data: () => ({
        categories: [],
        showNav: false,
        contact: {
            name: '',
            email: '',
            msg: '',
        },
        newsletter: {email: ''}
    }),
    mixins: [CartMixin],
    methods: {
        NewsletterSubscribe() {
            axios.post('/subscribe', this.newsletter)
                .then(rsp => alert(rsp.data.msg))
                .catch(err => {
                    let $errors = err.response.data.errors;
                    console.log(err.response.data);
                    alert(Object.values($errors).join('\n'));
                })
                .catch(console.error)
        },
        ContactSubmit() {
            axios.post('/contact', this.contact)
                .then(rsp => alert(rsp.data.msg))
                .catch(err => {
                    let $errors = err.response.data.errors;
                    console.log(err.response.data);
                    alert(Object.values($errors).join('\n'));
                })
                .catch(console.error)
        }
    },
    mounted() {
        axios.get('/category/highlighted', {params: {limit: 5, nav: true}})
            .then(rsp => this.categories = rsp.data)
    }
}
</script>

<style lang="scss" scoped>
#cart-btn-main {
    position: relative;
    z-index: 1;

    .counter {
        position: absolute;
        top: -10px;
        right: -10px;
        z-index: 2;
        background-color: red;
        color: #fff;
        border-radius: 50%;
        font-size: 15px;
        width: 25px;
        height: 25px;
        display: block;
    }
}

.logged-btn {
    font-size: .9em;
    display: block;
    color: #000;
    text-decoration: none;
    margin-left: 15px;

    strong {
        font-size: .9em;
    }
}

#main-frontend-app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #fdfdfd;
    color: #292e31;
}

#main-frontend-content {
    flex: 1;
    overflow: hidden;
}

header {
    position: relative;
    z-index: 2;

    ul.nav {
        list-style: none;

        li {
            display: inline-block;

            a {
                color: inherit;
                text-decoration: none;
                display: block;
                padding: 0 5px;
            }
        }
    }

    ul.nav-bts {
        list-style: none;
        display: flex;

        li {
            display: inline-block;

            button {
                display: block;
                width: 2em;
                height: 2em;
                border-radius: 50%;
                border: none;
                background-color: var(--main-app-color);
                color: var(--main-app-color-text);
            }
        }

        img {
            height: 20px;
            width: 20px;
            object-position: center;
            object-fit: contain;
        }

        .mobile-hamb-btn {
            display: none;

            button {
                padding: 8px;
            }

            .bar {
                display: block;
                width: 20px;
                height: 5px;
                background-color: #fff;
                border-radius: 5px;

                &:not(:last-of-type) {
                    margin-bottom: 3px;
                }
            }

            @media (max-width: 1125px) {
                display: block;
            }
        }
    }

    .small-nav {
        padding: 5px;
        background-color: var(--main-app-color);
        color: var(--main-app-color-text);
    }

    .main-nav {
        box-shadow: 0 5px 7px -4px grey;
        padding: 15px;
        color: var(--main-app-color);
        font-size: 1.3em;

        ul.nav {
            li a {
                padding: 0 15px;

                &.router-link-exact-active {
                    font-weight: bolder;
                }
            }

            @media (max-width: 1125px) {
                position: absolute;
                top: 178px;
                left: 0;
                right: 0;
                color: #fff;
                display: block;
                overflow: auto;
                transition: all .5s ease;

                &:not(.show) {
                    height: 0;
                    opacity: 0;
                    pointer-events: none;
                }

                li {
                    position: relative;
                    z-index: 2;
                    display: block;
                    text-align: center;
                    padding: 5px;

                    &:first-child {
                        padding-top: 25px;
                    }

                    &:last-child {
                        padding-bottom: 25px;
                    }
                }
                &::before {
                    content: '';
                    background-color: var(--main-app-color);
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    right: 0;
                    left: 0;
                    opacity: .9;
                    z-index: 1;
                    border-bottom-left-radius: 5px;
                    border-bottom-right-radius: 5px;
                }
            }
            @media (max-width: 523px) {
                top: 201px;
            }
        }

        .logo {
            height: 75px;

            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
                object-position: left center;
            }
        }
    }
}

.dev-by a {
    color: var(--main-app-color);
}

footer {
    background-color: #f5f5f5;

    .form-control {
        border-radius: 0;
        background-color: #fdfdfd;
        border: none;
    }

    .footer-content {
        padding: 35px;
        display: flex;
        flex-wrap: wrap;

        @media (max-width: 975px) {
            display: block;
        }

        > * {
            flex: 1;
            padding: 15px;
        }

        a {
            color: var(--main-app-color);
            text-decoration: none;
        }
    }

    .footer-bottom {
        text-align: center;
        background-color: var(--main-app-color);
        color: var(--main-app-color-text);
    }
}


</style>
